import { useEffect, useState } from 'react';
import { api } from '../../services/api';
import {
  Alert,
  Box,
  Button,
  CircularProgress,
  FormControlLabel,
  Paper,
  Stack,
  Switch,
  Typography,
} from '@mui/material';
import { useUiSettings } from '../../contexts/UiSettingsContext';
import FeatureAccessMatrix from './ui/FeatureAccessMatrix';

export default function UiSettingsPanel() {
  const { showTestDhis2Tab, setShowTestDhis2Tab } = useUiSettings();

  const [saving, setSaving] = useState(false);
  const [saveMsg, setSaveMsg] = useState<{ type: 'success' | 'error'; text: string } | null>(null);
  const [localTestDhis2, setLocalTestDhis2] = useState(showTestDhis2Tab);

  useEffect(() => {
    setLocalTestDhis2(showTestDhis2Tab);
  }, [showTestDhis2Tab]);

  const handleSave = async () => {
    setSaving(true);
    setSaveMsg(null);
    try {
      await api.put(`/system-config/ui`, {
        config_value_json: {
          show_test_dhis2_tab: localTestDhis2,
        },
      });
      setShowTestDhis2Tab(localTestDhis2);
      setSaveMsg({ type: 'success', text: 'Settings saved.' });
    } catch {
      setSaveMsg({ type: 'error', text: 'Failed to save settings.' });
    } finally {
      setSaving(false);
    }
  };

  return (
    <Stack spacing={3} sx={{ maxWidth: 860 }}>
      {/* General toggle */}
      <Paper variant="outlined" sx={{ p: 2 }}>
        <Typography variant="subtitle2" sx={{ fontWeight: 600, mb: 1.5 }}>
          General
        </Typography>
        <FormControlLabel
          control={
            <Switch
              checked={localTestDhis2}
              onChange={(e) => setLocalTestDhis2(e.target.checked)}
            />
          }
          label="Show Test DHIS2 tab"
        />
      </Paper>

      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
        <Button
          variant="contained"
          onClick={() => void handleSave()}
          disabled={saving}
          sx={{ textTransform: 'none' }}
        >
          {saving ? 'Saving…' : 'Save settings'}
        </Button>
        {saving && <CircularProgress size={16} />}
      </Box>

      {saveMsg && (
        <Alert severity={saveMsg.type} onClose={() => setSaveMsg(null)}>
          {saveMsg.text}
        </Alert>
      )}

      {/* Feature Access Matrix — manages its own save */}
      <FeatureAccessMatrix />
    </Stack>
  );
}
